import CreateItemPage from '../items/CreateItemPage';
import EditItemPage from '../items/EditItemPage';

/**
 * Wedding create entry stays on CreateItemPage.
 * Wedding edit reuses EditItemPage in wedding mode so moved listings
 * keep bridal/soiree categories instead of the pre-owned form.
 */
export const CreateWeddingPreLovedItemPage = () => (
  <CreateItemPage preferredCategoryGroup="wedding" />
);

export const EditWeddingPreLovedItemPage = () => <EditItemPage weddingPreLovedMode />;

export default CreateWeddingPreLovedItemPage;
